import {post} from '../../request'


/**
 * 文章分类列表
 * @param data
 * @returns {*}
 */
export function articleCategoryList(data) {
    return post("admin/article.Articlecategory/index", data)
}

/**
 * 文章分类
 * @param data
 * @returns {*}
 */
export function getArticleCategory(data) {
    return post("admin/article.article/getArticleCategory", data)
}

export function createArticleCategory(data) {
    return post("admin/article.Articlecategory/add", data)
}

/**
 * 获取修改的数据
 * @param data
 * @returns {*}
 */
export function getEditData(data){
    return post("admin/article.Articlecategory/getEditData", data);
}

/**
 * 修改分类
 * @param data
 * @returns {*}
 */
export function editsArticleCategory(data) {
    return post("admin/article.Articlecategory/edits", data)
}
/**
 * 删除分类
 * @param data
 * @returns {*}
 */
export function deleteArticleCategory(data) {
    return post("admin/article.Articlecategory/delete", data)
}

/**
 * 是否启用
 * @param data
 * @returns {*}
 */
export function isqiyongArticleCategory(data) {
    return post("admin/article.Articlecategory/isqiyong", data)
}

